// extracted by mini-css-extract-plugin
export default {"hubSwitcherWrapper":"zsvlEXpijKrkaS8I3xYq"};